<template>
 <div class="page t-container">
     <section class="t-mt-12 t-flex-col t-space-y-8 lg:t-space-y-0 lg:t-flex-row" role="main">
        <div class="t-flex t-flex-col t-space-y-8 lg:t-w-full lg:t-mr-8">
            <section class="dashboard-content t-flex-col t-rounded-md t-p-4 t-bg-white">
                <div style="border-bottom: 2px solid #EEEEEE;" class="t-pt-2 t-pb-4">
                    <h3 class="t-text-xl t-font-bold">
                        Export Bookings as CSV
                    </h3>
                </div>
                <form class="w-full max-w-sm" @submit.prevent="exportBookings">
                    <div class="t-text-gray-700 md:flex md:items-center">
                        <div class="t-mt-3 md:mb-0 md:w-1/3">
                            <label for="statuses">Include bookings</label>
                        </div>
                        <div class="md:w-2/3 md:flex-grow">
                            <multiselect 
                                v-model="statuses" 
                                :options="statusOptions" 
                                :multiple="true" 
                                :close-on-select="false" 
                                :clear-on-select="false" 
                                :preserve-search="true" 
                                :preselect-first="true"
                                placeholder="Pick statuses" 
                                label="name"
                                track-by="id"
                            ></multiselect>
                            <small v-if="errors && errors.statuses" class="t-text-xs t-text-red-500">{{ errors.statuses[0] }}</small>
                        </div>
                    </div>

                    <div class="t-text-gray-700 md:flex md:items-center">
                        <div class="t-mt-3 md:mb-0 md:w-1/3">
                            <label for="start_date">Start date</label>
                        </div>
                        <div class="md:w-2/3 md:flex-grow">
                            <datepicker
                                :bootstrap-styling="true" 
                                :format="'D, dsu MMM yy'"
                                v-model="start_date"
                            ></datepicker>
                            <small v-if="errors && errors.start_date" class="t-text-xs t-text-red-500">{{ errors.start_date[0] }}</small>
                        </div>
                    </div>

                    <div class="t-text-gray-700 md:flex md:items-center">
                        <div class="t-mt-3 md:mb-0 md:w-1/3">
                            <label for="end_date">End date</label>
                        </div>
                        <div class="md:w-2/3 md:flex-grow">
                            <datepicker 
                                :bootstrap-styling="true"
                                :format="'D, dsu MMM yy'"
                                v-model="end_date"
                            ></datepicker>
                            <small v-if="errors && errors.end_date" class="t-text-xs t-text-red-500">{{ errors.end_date[0] }}</small>
                            <p class="t-text-xs">Bookings with a "pickup after" date on and between these dates will be exported.</p>
                        </div>
                    </div>

                    <div class="flex items-center justify-between">
                        <button class="t-bg-green-500 hover:bg-green-700 t-text-white t-font-bold t-py-2 t-px-4 t-mt-4 t-rounded" type="submit">
                            Download <i class="fa fa-check"></i>
                        </button>
                    </div>
                </form>
            </section>
        </div>
     </section>
 </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect';
import axios from 'axios';

export default {
    name: "ExportBookingCard",
    components: {
        Multiselect,
        Datepicker
    },

    data() {
        return {
            statusOptions: [
                { id: 3, name: "Awaiting pickup" },
                { id: 4, name: "Awaiting delivery" },
                { id: 5, name: "Delivered" },
                { id: 9, name: "Cancelled" }
            ],
            statuses: [],
            start_date: new Date(Date.now() - 604800000),
            end_date: new Date(),
            errors: {},
            loaded: true,
        }
    },
    methods: {
        exportBookings(){
            if (this.loaded) {
                this.loaded = false;
                this.errors = {};
                axios.post('/send-freight/bookings/export', {
                    statuses: this.newStatuses,
                    start_date: this.startDate,
                    end_date: this.endDate,
                    responseType: 'blob',
                })
                .then(response => {
                    this.loaded = true;
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', response.headers['content-disposition'].split('filename=')[1].split(';')[0]);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(error => {
                    this.loaded = true;
                    if (error.response !== undefined) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors || {};
                        }
                    }
                })
            }
        },
        destructure(array){
            return array.map(({id}) => ({id}));
        }
    },
    computed: {
        newStatuses(){
            return this.destructure(this.statuses);
        },
        startDate(){
            return moment(this.start_date).format('ddd, Do MMM YY');
        },
        endDate(){
            return moment(this.end_date).format('ddd, Do MMM YY');
        }
    }
}
</script>